export function Wordmark() {
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <div
        style={{
          width: 26,
          height: 26,
          borderRadius: 6,
          background: 'var(--ink)',
          color: 'var(--surface-1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M7 9V4h10v5" />
          <rect x="4" y="9" width="16" height="8" rx="1" />
          <rect x="7" y="14" width="10" height="6" />
        </svg>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
        <span
          style={{
            fontFamily: 'var(--font-serif)',
            fontSize: 15,
            fontWeight: 600,
            letterSpacing: '.05em',
            color: 'var(--ink)',
            lineHeight: 1,
          }}
        >
          排版打印
        </span>
        <span
          style={{
            fontSize: 8.5,
            color: 'var(--ink-3)',
            letterSpacing: '.18em',
            fontWeight: 500,
            textTransform: 'uppercase',
            marginTop: 3,
            whiteSpace: 'nowrap',
            fontFamily: 'var(--font-ui)',
          }}
        >
          Layout&nbsp;·&nbsp;Print
        </span>
      </div>
    </div>
  );
}
